import React from "react";
import "../styles/FrontPage.css";
import "../styles/Flowers.css";

import IntrebariFrecvente from "../components/IntrebariFrecvente";
import CeleMaiVinduteHome from "../pages/CeleMaiVinduteHome";
import CumFunctioneaza from "../components/CumFunctioneaza";
import Lacetegindesti from "../components/Lacetegindesti";
import LivrareFront from "../components/LivrareFront";
import image1 from "../img/front-image-1.webp";

const Home = () => {
  return (
    <div className="home">
      {/* Front Page Section - Static Single Image */}
      <div className="front-page">
        <div className="slide">
          <img
            src={image1}
            alt="Flori proaspete, atent selecționate"
            className="slide-image"
          />
          <div className="front-page-content">
            <h1 className="front-page-title">Selecția Gardenia Flowers</h1>
            <a href="#cele-mai-vindute" className="btn buyNow">
              Comanda acum
            </a>
          </div>
        </div>
      </div>

      <div>
        <CeleMaiVinduteHome />
        <CumFunctioneaza />
        <LivrareFront />
        <Lacetegindesti />
        <IntrebariFrecvente />
      </div>
    </div>
  );
};

export default Home;
